<template>
  <div class="contranter">
    <div class="banner-sch">
      <Topbar :tab_index="tab_index" :had_login="had_login"></Topbar>
      <img src="@/assets/schedule-logo.png" class="major" />
      <video src="@/assets/video.mp4" class="sch-video" controls autoplay></video>
    </div>
    <img src="@/assets/sch-process.png" class="sch-process" />
  </div>
</template>

<script>
import api from "../api/api";
import ops from "../leo.wang.util/operator.string";
import Topbar from "../components/Topbar.vue";
import pub from "../common/pub.js";
import Swiper from "swiper";
import $ from "jquery";
export default {
  name: "Dashboard",
  components: {
    Topbar: Topbar,
  },
  data() {
    return {
      title: "AXOR室内设计奖",
      tab_index: 1,
      had_login: false,
    };
  },
  methods: {
    naviToDetail(item) {
      // this.$router.push()
    },
  },
  created() {
    //window.document.title = this.title;
    let that = this;
  },
  mounted() {
    let that = this;
    let phone_number = localStorage.getItem("mobile");
    if (phone_number) {
      this.had_login = true;
      api
        .getMyInfo({
          user_phone: ops.encode(phone_number),
        })
        .then((res) => {
          that.u_info = res.data.data.info;
        });
    }
  },
};
</script>

<style scoped>
.banner-sch {
  width: 100vw;
  height: calc(1080 / 1920 * 100vw);
  background: url("../assets/schedule-bg.png") no-repeat;
  background-size: cover;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/Schedule.vue